import './style.css';
import {Map, View} from 'ol';
import TileWMS from 'ol/source/TileWMS';
import GeoJSON from 'ol/format/GeoJSON.js';
import {Fill, Stroke, Style} from 'ol/style.js';
import {Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {Attribution, defaults as defaultControls} from 'ol/control.js';
import Overlay from 'ol/Overlay';

// common conf for different vineyards
const lagen = {
  pechstein: {
    title: 'Pechstein',
    geojson: './pechstein.geojson'
  },
  ungeheuer: {
    title: 'Forster Ungeheuer',
    geojson: './ungeheuer.geojson'
  },
  kirchenstueck: {
    title: 'Kirchenstück',
    geojson: './kirchenstueck-lerchenspiel.geo.json'
  }
};

const lage = 'ungeheuer';

/**
 *
 * @returns
 */
async function loadGeoJson () {
  const lagenObj = lagen[lage];

  // load GeoJSON
  const resp = await fetch(lagenObj.geojson);
  const geojson = await resp.json();

  // set title
  document.querySelector('#map-header h2').innerHTML = 'Lagenkarte ' + lagenObj.title;

  return geojson;
}

/**
 * Creates an interactive map with the vineyard geometry.
 *
 * @param {Object|String} geojson The GeoJSON of the vineyard
 */
function createMap (geojson) {
  const bgLayer = new TileLayer({
    source: new TileWMS({
      url: 'https://sgx.geodatenzentrum.de/wms_basemapde',
      params: {
        'LAYERS': 'de_basemapde_web_raster_grau'
      },
      attributions: '© basemap.de / BKG'
    })
  });

  const vineyardFeatures = new GeoJSON({
    dataProjection: 'EPSG:4326',
    featureProjection:'EPSG:3857'
  }).readFeatures(geojson);

  const vectorSource = new VectorSource({
    features: vineyardFeatures
  });

  const vectorLayer = new VectorLayer({
    source: vectorSource,
    style: new Style({
      stroke: new Stroke({
        color: '#48244d',
        // color: 'rgb(128,26,51)',
        width: 2,
      }),
      fill: new Fill({
        color: 'rgba(0, 255, 0, 0.3)',
      }),
    })
  });

  const attribution = new Attribution({
    collapsible: false,
  });

  const map = new Map({
    target: 'map',
    layers: [
      bgLayer,
      vectorLayer
    ],
    view: new View({
      center: [910807.0,6348051.2],
      zoom: 14
    }),
    controls: defaultControls({attribution: false}).extend([attribution]),
  });

  const feature = vineyardFeatures[0];
  var extent = feature.getGeometry().getExtent();
  map.getView().fit(feature.getGeometry(), {padding: [20, 20, 20, 20], maxZoom: 15});

  return map;
}

/**
 *
 * @param {*} map
 */
function registerPopup (map) {
  const container = document.getElementById('popup');
  const content = document.getElementById('popup-content');

  /**
   * Create an overlay to anchor the popup to the map.
   */
  const overlay = new Overlay({
    element: container,
    autoPan: {
      animation: {
        duration: 250,
      },
    },
  });
  map.addOverlay(overlay);

  // add a click handler to the map to render the popup.
  map.on('singleclick', function (evt) {
    const coordinate = evt.coordinate;
    const feature = map.getFeaturesAtPixel(evt.pixel)[0];
    let popupText = '';
    if (feature) {
      popupText = `<p>Lage: ${feature.get('wlg_name')} <br>
      Größe: ${feature.get('rebflache_ha')} Hektar <br>
      Großlage: ${feature.get('grosslage') } <br>
      Gemeinde: ${feature.get('gemeinde') }<p>`;

      content.innerHTML = popupText;
      overlay.setPosition(coordinate);
    } else {
      overlay.setPosition(null);
    }
  });
}

/**
 *
 */
async function showClimateData () {
  const lagenObj = lagen[lage];
  document.querySelector('#climate-header h2').innerHTML = 'Klima ' + lagenObj.title;

  const response = await fetch('./duew-temp-multi-annual.json');

  const climateJson = await response.json();

  console.log(climateJson);

  let climateText = '';
  // climateJson.forEach(timeRangeInfo => {
  //   climateText += parseTimeRange(timeRangeInfo);
  //   climateText += '<br><br>';
  // });

  climateText = parseTimeRange(climateJson[1]);

  document.querySelector('.climate-info').innerHTML = climateText;
}

/**
 *
 * @param {*} timerangeInfo
 */
function parseTimeRange (timeRangeInfo) {
  let text = '';

  text += '<h4>&empty; - Temperatur ' + timeRangeInfo['Bezugszeitraum'] + '</h4>';

  text += '<table class="tg"><thead>';

  text += getClimateRow(timeRangeInfo, 'Januar', 'Jan.');
  text += getClimateRow(timeRangeInfo, 'Februar', 'Feb.');
  text += getClimateRow(timeRangeInfo, 'März', 'März');
  text += getClimateRow(timeRangeInfo, 'April', 'Apr.');
  text += getClimateRow(timeRangeInfo, 'Mai', 'Mai');
  text += getClimateRow(timeRangeInfo, 'Juni', 'Jun.');
  text += getClimateRow(timeRangeInfo, 'Juli', 'Jul.');
  text += getClimateRow(timeRangeInfo, 'August', 'Aug.');
  text += getClimateRow(timeRangeInfo, 'September', 'Sept.');
  text += getClimateRow(timeRangeInfo, 'Oktober', 'Okt.');
  text += getClimateRow(timeRangeInfo, 'November', 'Nov.');
  text += getClimateRow(timeRangeInfo, 'Dezember', 'Dez.');

  text +=  '</thead></table>';

  return text;
}

/**
 *
 * @returns
 */
function getClimateRow (timeRangeInfo, monthText, monthKey) {
  return `<tr>
    <td class="tg-0lax key-col">${monthText}</td>
    <td class="tg-0lax val-col">${formatClimateValue(timeRangeInfo[monthKey])} °C</td>
  </tr>`;
}

/**
 *
 * @param {*} val
 * @returns
 */
function formatClimateValue (val) {
  return parseFloat(val).toFixed(1);
}

(async () => {
  const geojson = await loadGeoJson();
  const map = createMap(geojson);

  registerPopup(map);

  showClimateData();
})();
